import {
    ccOthersAction,
    closeAction,
    messageChangedAction,
    notifyManagerAction,
    sendRemindersAction,
    updateUserAction,
} from 'components/core/task/send_reminder/actions'
import { Record as ImmutableRecord } from 'immutable'
import { AccessReviewsAction } from 'lib/actions/access_review'
import { GetSendReminderPreview, TasksAction } from 'lib/actions/task'
import { Status } from 'lib/rpc'
import { User } from 'pbts/c1/api/user/v1/user'

export class SendRemindersState extends ImmutableRecord({
    open: true,
    hasReceivers: true,
    canShowManager: false,
    copiedUsers: [] as User[],
    notifyManager: false,
    message: '',
    ccOthers: false,
    sent: false,
}) {}

const handleGetSendRemindersPreview = (
    action: GetSendReminderPreview,
    state: SendRemindersState,
): SendRemindersState => {
    if (action.payload.status !== Status.OK) {
        return state
    }
    if (action.payload.item.users.length === 0) {
        return state.set('hasReceivers', false)
    }
    const found = action.payload.item.users.findIndex((u: User): boolean => u.managerIds.length > 0)
    return state.set('canShowManager', found !== -1)
}

const reducer = (state: SendRemindersState, action: sendRemindersAction): SendRemindersState => {
    switch (action.type) {
        case TasksAction.sendReminder:
        // fallthrough
        case AccessReviewsAction.campaignReminder:
            if (action.payload.status !== Status.OK) {
                return state
            }
            return state.set('sent', true)
        case closeAction:
            return state.set('open', false).set('sent', false)
        case updateUserAction:
            return state.set('copiedUsers', action.users)
        case notifyManagerAction:
            return state.set('notifyManager', action.value)
        case ccOthersAction:
            return state.set('ccOthers', action.value)
        case messageChangedAction:
            return state.set('message', action.message)
        case TasksAction.getSendReminderPreview:
            return handleGetSendRemindersPreview(action, state)
        // no default
    }
    return state
}
export default reducer
